<template>
  <div class="calendar_box">
    <FullCalendar
        class='demo-app-calendar'
        :options='calendarOptions'
        ref="fullCalendar"
    >
      <template v-slot:eventContent='arg'>
        <el-row>
          <el-col :span="5" class="schedule-text">时间：</el-col>
          <el-col :span="14" class="schedule-value">{{ arg.timeText }}</el-col>
          <el-col :span="4" class="schedule-value">{{ arg.event.extendedProps.type }}</el-col>
        </el-row>
        <el-row>
          <el-col :span="5" class="schedule-text">内容：</el-col>
          <el-col :span="18" class="schedule-value">{{ arg.event.extendedProps.schedule_plan }}</el-col>
        </el-row>
        <el-row>
          <el-col :span="5" class="schedule-text">结果：</el-col>
          <el-col :span="18" class="schedule-value">{{ arg.event.extendedProps.result }}</el-col>
        </el-row>
        <el-row>
          <el-col :span="5" class="schedule-text">批注：</el-col>
          <el-col :span="18" class="schedule-value">{{ arg.event.extendedProps.comments }}</el-col>
        </el-row>
      </template>
    </FullCalendar>
    <div class="my_toolbar">
      <el-select v-model="user_id" placeholder="人员" class="toolbar_item" style="width: 130px" clearable>
        <el-option v-for="item in userList" :key="item.id" :label="item.full_name" :value="item.id"></el-option>
      </el-select>
      <el-button type="primary" @click="scheduleQuery" class="toolbar_item">查询</el-button>
      <el-button type="primary" @click="insertSchedule" class="toolbar_item">添加</el-button>
      <el-button type="primary" @click="isExport" class="toolbar_item">导出</el-button>
    </div>

    <div style="margin-top: 5px;margin-left: 10px">
      *点击日程查看详情
    </div>

    <!--添加日程dialog -->
    <el-dialog title="日程安排" :model="formData" v-model="dialogFormVisible" style="width: 700px">
      <el-form label-width="150px" :rules="rules">
        <el-form-item label="日期：" prop="star">
          <el-date-picker
              v-model="formData.schedule_date"
              type="date"
              placeholder="请选择日期"
              style="width: 250px"
          />
        </el-form-item>
        <el-form-item label="类型：" prop="star">
          <el-select v-model="formData.type" style="width: 250px" clearable>
            <el-option v-for="dict in scheduleType" :key="dict.value" :label="dict.name"
                       :value="dict.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="日程内容：" prop="star">
          <el-input type="textarea" v-model="formData.schedule_plan" style="width: 400px" clearable>
          </el-input>
        </el-form-item>
        <el-form-item label="日程选择：" >
          <el-select v-model="formData.schedule_range" style="width: 250px" clearable>
            <el-option v-for="dict in scheduleRange" :key="dict.value" :label="dict.name"
                       :value="dict.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="开始时间：" >
          <el-time-select
              v-model="formData.start_time"
              start="00:00"
              step="00:30"
              end="24:00"
              placeholder="请选择时间"
              style="width: 250px"
          />
        </el-form-item>
        <el-form-item label="结束时间：" >
          <el-time-select
              v-model="formData.end_time"
              start="00:00"
              step="00:30"
              end="24:00"
              placeholder="请选择时间"
              style="width: 250px"
          />
        </el-form-item>
        <el-form-item label="提醒时间：">
          <el-select v-model="formData.reminder_time" style="width: 250px" clearable>
            <el-option v-for="dict in reminderTime" :key="dict.value" :label="dict.name"
                       :value="dict.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button @click="submit" :loading="loading">提交</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>


    <!--导出日程dialog -->
    <el-dialog title="日程导出" :model="form" v-model="dialogFormExport" style="width:700px">
      <FrameForm componentParam="schedule_export" :init-data="formData"/>
    </el-dialog>


    <!--日程详情dialog -->
    <el-dialog title="日程详情" :model="form" v-model="dialogForm">
      <el-tabs v-model="activeName" class="scheduleDetail" @tab-click="handleClick">
        <el-tab-pane label="日程安排" name="first">
          <el-form label-width="150px">
            <el-row>
              <el-col :span="3" style="margin-top: 10px;text-align: right">人员：</el-col>
              <el-col :span="10" style="margin-top: 10px">{{ form.user_name }}</el-col>
            </el-row>
            <el-row>
              <el-col :span="3" style="margin-top: 10px;text-align: right">开始时间：</el-col>
              <el-col :span="10" style="margin-top: 10px">{{ form.start_time }}</el-col>
            </el-row>
            <el-row>
              <el-col :span="3" style="margin-top: 10px;text-align: right">结束时间：</el-col>
              <el-col :span="10" style="margin-top: 10px">{{ form.end_time }}</el-col>
            </el-row>
            <el-row>
              <el-col :span="3" style="margin-top: 10px;text-align: right">内容：</el-col>
              <el-col :span="10" style="margin-top: 10px">{{ form.schedule_plan }}</el-col>
            </el-row>
            <el-row>
              <el-col :span="3" style="margin-top: 10px;text-align: right">类型：</el-col>
              <el-col :span="10" style="margin-top: 10px">{{ form.type }}</el-col>
            </el-row>
            <el-row>
              <el-col :span="3" style="margin-top: 10px;text-align: right">提醒时间：</el-col>
              <el-col :span="10" style="margin-top: 10px">{{ form.reminder_time }}</el-col>
            </el-row>
            <el-row>
              <el-col :span="3" style="margin-top: 10px;text-align: right">执行结果：</el-col>
              <el-col :span="10" style="margin-top: 10px">
                <el-select v-model="form.result" style="width: 250px;" clearable>
                  <el-option v-for="dict in scheduleResult" :key="dict.value" :label="dict.name"
                             :value="dict.value"></el-option>
                </el-select>
              </el-col>
            </el-row>
            <el-row v-if="form.result == 'schedule_partial' || form.result == 'schedule_no_start'">
              <el-col :span="3" style="margin-top: 10px;text-align: right">备注：</el-col>
              <el-col :span="10" style="margin-top: 10px">
                <el-input type="textarea" v-model="form.remark" style="width: 400px" clearable></el-input>
              </el-col>
            </el-row>
            <el-form-item>
              <el-button @click="updateSchedule" :loading="loading" style="margin-left: -27px;margin-top: 20px">
                提交结果
              </el-button>
              <el-button @click="deleteSchedule" :loading="loading" style="margin-left: 50px;margin-top: 20px">
                删除日程
              </el-button>
            </el-form-item>
          </el-form>
        </el-tab-pane>

        <el-tab-pane label="批注" name="second">
          <el-form-item label="批注" prop="result">
            <el-input v-model="form.comments" style="width: 250px" clearable>
            </el-input>
            <el-button @click="addScheduleComments" :loading="loading" style="margin-left: 20px">添加批注</el-button>
          </el-form-item>
          <el-table :data="form.commentsList" v-loading="loading" style="font-size: 16px">
            <el-table-column>
              <template #default="props">
                <div>
                  <div style="width: 300px;font-size: 14px;color: #515C5F">{{ props.row.user_name }}
                    {{ props.row.create_time }}
                  </div>
                  <div style="color: burlywood">{{ props.row.comments }}</div>
                </div>
              </template>
            </el-table-column>
          </el-table>

        </el-tab-pane>
      </el-tabs>
    </el-dialog>
  </div>
</template>

<script>
import FullCalendar from "@fullcalendar/vue3";
import dayGridPlugin from '@fullcalendar/daygrid'
import timeGridPlugin from '@fullcalendar/timegrid'
import interactionPlugin from '@fullcalendar/interaction'
import moment from "moment";

export default {
  name: "ScheduleManage",
  components: {
    FullCalendar,
  },
  data() {
    return {
      activeName: 'first',
      rules: {
        star: [{required: true, message: '', trigger: 'blur'}],
      },
      // scheduleType: [],
      // scheduleState: [],
      userList: [],
      user_id: '',
      dialogForm: false,
      dialogFormVisible: false,
      dialogFormExport: false,
      users: [],
      params: {},
      viewVisible: false,
      selectId: 0,
      selectDate: '',
      saveVisible: false,
      queryListEventMap: {
        button_id: '',
        query_id: '',
        start_date: ''
      },
      formExport: {
        user_id: '',
        export_start_time: '',
        export_end_time: ''
      },
      form: {
        id: '',
        user_id: '',
        user_name: '',
        title: '',
        type: '',
        comments: '',
        result: '',
        start_time: '',
        end_time: '',
        remark: '',
        commentsList: []
      },
      formData: {
        schedule_range: '',
        schedule_date: '',
        user_id: '',
        schedule_plan: '',
        type: '',
        result: '',
        start_time: '',
        end_time: '',
      },
      calendarOptions: {
        plugins: [dayGridPlugin, timeGridPlugin, interactionPlugin],
        aspectRatio: 3.21,
        allDaySlot: false,
        locale: "zh-cn",
        fixedWeekCount: false,
        customButtons: {
          next: {
            click: this.nextClick
          },
          prev: {
            click: this.prevClick
          },
          today: {
            text: "今天",
            click: this.todayClick
          },
        },
        headerToolbar: {
          left: "prev,next,today",
          center: "title",
          right: "",
        },
        initialView: "timeGridWeek",
        events: [],
        firstDay: 1,
        editable: false,
        selectable: true,
        // selectMirror: true,
        dayMaxEvents: true,
        weekends: true,
        eventClick: this.handleEventClick,
      },
      currentEvents: [],
      eventGuid: 0,
    };
  },
  computed: {
    scheduleType() {
      return this.$store.getters['core/getDictList']('schedule_type');
    },
    scheduleResult() {
      return this.$store.getters['core/getDictList']('schedule_result');
    },
    scheduleRange() {
      return this.$store.getters['core/getDictList']('schedule_range');
    },
    reminderTime() {
      return this.$store.getters['core/getDictList']('reminder_time');
    },
  },
  created() {
    this.fullName();
    this.scheduleQuery()
    this.getUserList()
  },
  methods: {
    windowResize() {
      this.$refs.fullCalendar.getApi().updateSize()
    },
    nextClick() {
      this.$refs.fullCalendar.getApi().next()
      this.scheduleQuery()
    },

    prevClick() {
      this.$refs.fullCalendar.getApi().prev()
      this.scheduleQuery()
    },

    todayClick() {
      this.$refs.fullCalendar.getApi().today()
      this.scheduleQuery()
    },

    clearData() {
      this.formData.schedule_date = ''
      this.formData.schedule_range = ''
      this.formData.user_id = ''
      this.formData.schedule_plan = ''
      this.formData.type = ''
      this.formData.result = ''
      this.formData.start_time = ''
      this.formData.end_time = ''
      this.form.user_id = ''
      this.form.title = ''
      this.form.comments = ''
      this.form.type = ''
      this.form.result = ''
      this.form.start_time = ''
      this.form.end_time = ''
      this.form.remark = ''
    },

    fullName() {
      this.user_id = this.$store.state.core.currentUser?.id
      this.formData.user_id = this.$store.state.core.currentUser?.id
    },

    //添加日程
    submit() {
      if (!this.formData.schedule_date) {
        return this.$message.error('请选择日期')
      }
      if (!this.formData.schedule_plan) {
        return this.$message.error('请输入内容')
      }
      if (!this.formData.type) {
        return this.$message.error('请选择类型')
      }
      if (this.formData.schedule_range) {
        if (this.formData.start_time || this.formData.end_time) {
          return this.$message.error('日程选择和时间不能同时输入')
        }
      }
      if (!this.formData.schedule_range) {
        if (!this.formData.start_time || !this.formData.end_time) {
          return this.$message.error('日程选择和时间输入其中一个')
        }
      }
      this.formData.user_id = this.$store.state.core.currentUser?.id
      this.formData.schedule_date = moment(new Date(this.formData.schedule_date)).format('yyyy-MM-DD')
      this.$axios.post('schedule/addSchedule', this.formData).then(response => {
        this.loading = false
        let res = response.data;
        if (res.code !== 0) {
          return this.$message.error(res.message);
        } else {
          this.dialogFormVisible = false;
          this.scheduleQuery()
          this.clearData()
          return this.$message.success("提交成功");
        }
      }, error => {
        this.loading = false
        return this.$refs.searchMessage.showError(error.message)
      })
    },

    //添加批注
    addScheduleComments() {
      if (!this.form.comments) {
        return this.$message.error('请输入批注')
      }
      this.$axios.post('schedule/addScheduleComments', this.form).then(response => {
        this.loading = false
        let res = response.data;
        if (res.code !== 0) {
          return this.$message.error("提交失败");
        } else {
          this.dialogForm = false;
          this.scheduleQuery()
          return this.$message.success("提交成功");
        }
      }, error => {
        this.loading = false
        return this.$refs.searchMessage.showError(error.message)
      })
    },

    //添加反馈
    updateSchedule() {
      if (!this.form.result) {
        return this.$message.error('请选择执行结果')
      }
      this.$axios.post('schedule/updateSchedule', this.form).then(response => {
        this.loading = false
        let res = response.data;

        console.log(res.code)
        if (res.code !== 0) {
          return this.$message.error("编辑失败" + res.message);
        } else {
          this.dialogForm = false;
          this.scheduleQuery()
          this.clearData()
          return this.$message.success("编辑成功");
        }
      }, error => {
        this.loading = false
        return this.$refs.searchMessage.showError(error.message)
      })
    },

    //删除日程
    deleteSchedule() {
      this.$axios.post('schedule/scheduleDelete', this.form).then(response => {
        this.loading = false
        let res = response.data;

        console.log(res.code)
        if (res.code !== 0) {
          return this.$message.error(res.message);
        } else {
          this.dialogForm = false;
          this.scheduleQuery()
          return this.$message.success("删除成功");
        }
      })
    },

    //查询日程
    scheduleQuery() {
      if (!this.user_id) {
        return this.$message.error('请选择人员')
      }
      this.$axios.post('schedule/getSchedule', this.user_id).then(response => {
        this.loading = false
        let res = response.data;
        if (res.code !== 0) {
          return this.$message.error("查询失败");
        } else {
          //赋值
          this.calendarOptions.events = res.data.itemList

        }
      }, error => {
        this.loading = false
        return this.$refs.searchMessage.showError(error.message)
      })
    },

    insertSchedule() {
      this.dialogFormVisible = true;
    },

    isExport() {
      this.dialogFormExport = true;
    },

    //查询详情
    handleEventClick(clickInfo) {
      this.clearData()
      this.dialogForm = true;
      console.log(clickInfo)
      this.form.id = clickInfo.event.id
      this.$axios.post('schedule/getScheduleDetails', clickInfo.event.id).then(response => {
        this.loading = false
        let res = response.data;

        if (res.code !== 0) {
          return this.$message.error("查询失败");
        } else {

          this.form = res.data
          console.log(this.form.commentsList)
        }
      }, error => {
        this.loading = false
        return this.$refs.searchMessage.showError(error.message)
      })
    },

    getUserList() {
      this.$axios.post('schedule/getUserList').then(response => {
        let res = response.data
        if (res.code != 0) {
          return this.$message.error("获取失败");
        }
        this.userList = res.data.itemList;

      })
    },

  },

}

</script>


<style lang="less" scoped>
.calendar_box {
  width: 100%;
  height: 80%;
  padding: 20px;
}

.my_toolbar {
  position: absolute;
  top: 25px;
  right: 50px;
  text-align: left;
  line-height: 40px;
  vertical-align: middle;
  /*border: 1px dotted lightgray;*/
  display: inline-flex;

}

.toolbar_item {
  margin-right: 10px;
}

.schedule-text {
  font-size: 14px;
}

.schedule-value {
  font-size: 14px;
}

.scheduleDetail {
  font-size: 16px;
}

</style>